import { render, staticRenderFns } from "./widgetHref.vue?vue&type=template&id=927eebda&scoped=true&"
import script from "./widgetHref.vue?vue&type=script&lang=js&"
export * from "./widgetHref.vue?vue&type=script&lang=js&"
import style0 from "./widgetHref.vue?vue&type=style&index=0&id=927eebda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927eebda",
  null
  
)

export default component.exports